export default "__VITE_ASSET__DL17v9wt__"